import { Component, computed, input, Input } from '@angular/core';
import { ProductCardModel } from 'src/business/openapi';
import { CommonModule } from 'src/common/common.module';
import { ImgDirective } from 'src/common/media/img.directive';
import { PricePipe } from 'src/common/pipes/price.pipe';
import { origin } from 'src/utils/origin';
import { ContentCacheUtils } from 'src/utils/storage.util';


@Component({
  selector: 'app-product-card',
  imports: [CommonModule, PricePipe, ImgDirective],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.css',

})
export class ProductCardComponent {
  fallbackImage = ContentCacheUtils.fallbackImage();
  product = input.required<ProductCardModel>();
  span = input<number>(1);
  srcset = computed(() => {
    let _product = this.product();
    let _span = this.span();
    let img = _product.images?.find(() => true)
    if (img == null)
      return '';
    return ProductCardComponent.productCardSrcset(img, _span);
  })

  private static productCardSrcset(use: string, span: number): string {
    if (!use || use == '')
      return '';
    return [150, 300, 465, 600]
      .map(size => `${this.getURL(use, { width: size * span, height: size })} ${size}w`)
      .join(', ');
  }

  private static getURL(use: string | null, size: { width: number, height: number }): URL {
    if (use == null)
      return new URL(ContentCacheUtils.fallbackImage());
    let _url = new URL(use, origin());
    _url.searchParams.set('width', size.width + '');
    _url.searchParams.set('height', size.height + '');
    return _url;
  }

}
